class ValidationError extends Error {
  constructor(details, statusText, defaultMessage, url) {
      const message = details?.Message ?? details?.title ?? statusText;
      super(message);

      if (Error.captureStackTrace) {
          Error.captureStackTrace(this, ValidationError);
      }

      this.title = details?.title ?? "Validation Error";
      this.statusCode = details?.StatusCode ?? details?.status;
      this.details = details?.Details ?? details ?? [];
      this.defaultMessage = defaultMessage;
      this.url = url;
  }
}

export default ValidationError;
